import React, { ReactNode } from 'react';

import { Button } from 'components/Button';
import SearchTile from 'components/SearchTile';
import { SlimSearchTile } from 'components/SlimSearchTile';

type SectionSearchTileProps = {
  layout: 'SLIM' | 'REGULAR';
  children: ReactNode;
};
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export const SectionSearchTile = ({
  layout,
  children,
}: SectionSearchTileProps) => {
  if (layout === 'REGULAR') {
    return (
      <SearchTile
        // @ts-expect-error Fix type
        component={Button}
        display="block"
        p="20px !important"
        width="100%"
        height={[310, null, 330]}
      >
        {children}
      </SearchTile>
    );
  }

  return (
    <SlimSearchTile
      component={Button}
      display="block"
      px="36px !important"
      py="20px !important"
      width="100%"
      height={200}
    >
      {children}
    </SlimSearchTile>
  );
};
